export default "__VITE_ASSET__CDoFOe3q__"